export const permissions = [
  {
    url: '/purchase-order/view',
    feature_id: 1,
    view: 1,
  },
  {
    url: '/purchase-order/bills/view',
    feature_id: 2,
    view: 1,
  },
  {
    url: '/purchase-order/all-bills',
    feature_id: 24,
    view: 1,
  },
  {
    url: '/purchase-order/view',
    feature_id: 2,
    view: 1,
  },
  {
    url: '/purchase-order/create',
    feature_id: 1,
    create: 1,
  },
  {
    url: '/purchase-order/bills/standalone',
    feature_id: 25,
    create: 1,
  },
  {
    url: '/purchase-order/edit',
    feature_id: 1,
    update: 1,
  },

  {
    url: '/smart-cart',
    feature_id: 1,
    create: 1,
  },
  {
    url: '/smart-cart/cart',
    feature_id: 1,
    create: 1,
  },
  {
    url: '/sale-order/view',
    feature_id: 3,
    view: 1,
  },
  {
    url: '/sale-order/create',
    feature_id: 3,
    create: 1,
  },
  {
    url: '/sale-order/edit',
    feature_id: 3,
    update: 1,
  },
  // {
  // url: 'Sales Order Invoices', //ask sir
  // feature_id: ,
  // create: ,
  // },

  //contact
  {
    url: '/contacts/vendor',
    feature_id: 17,
    view: 1,
  },
  {
    url: '/contacts/customer',
    feature_id: 18,
    view: 1,
  },
  {
    url: '/contacts/staff',
    feature_id: 19,
    view: 1,
  },
  // {
  //   url: '/contacts/create',
  //   feature_id: 17,
  //   create: 1,
  // },
  {
    url: '/contacts/create/vendor',
    feature_id: 17,
    create: 1,
  },
  {
    url: '/contacts/create/customer',
    feature_id: 18,
    create: 1,
  },
  {
    url: '/contacts/create/staff',
    feature_id: 19,
    create: 1,
  },

  //products
  {
    url: '/products/edit/product', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/product', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/create/product', //for raw material
    feature_id: 20,
    create: 1,
  },
  {
    url: '/products/create/product', // for recipes
    feature_id: 21,
    create: 1,
  },
  {
    url: '/products/edit/recipe', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/recipe', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/buyer', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/buyer', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/seller', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/seller', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/purchase-order', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/purchase-order', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/sale-order', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/sale-order', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/stock-level', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/stock-level', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/consumption-history', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/consumption-history', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/sales-channel', //for raw material
    feature_id: 20,
    update: 1,
  },
  {
    url: '/products/edit/sales-channel', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/edit/product-timeline', // for recipes
    feature_id: 21,
    update: 1,
  },
  {
    url: '/products/raw-materials',
    feature_id: 20,
    view: 1,
  },
  {
    url: '/products/recipes',
    feature_id: 21,
    view: 1,
  },
  {
    url: '/products/categories',
    feature_id: 22,
    view: 1,
  },
  // {
  //   url: '/products/sub-recipes',
  //   feature_id: ,
  //   view: 1,
  // },
  // {
  //   url: '/products/packaging',
  //   feature_id: ,
  //   view: 1,
  // },
  // {
  //   url: '/products/others',
  //   feature_id: ,
  //   view: 1,
  // },

  {
    url: '/planning/list',
    feature_id: 7,
    view: 1,
  },
  {
    url: '/planning/view',
    feature_id: 7,
    view: 1,
  },
  {
    url: '/planning/create',
    feature_id: 7,
    create: 1,
  },
  {
    url: '/reports',
    feature_id: 8,
    view: 1,
  },
  // {
  //   url: '/reports/all-pricing',
  //   feature_id: 8,
  //   view: 1,
  // },
  // {
  //   url: '/reports/recipe-pricing',
  //   feature_id: 8,
  //   view: 1,
  // },
  // {
  //   url: '/reports/current-stock',
  //   feature_id: 8,
  //   view: 1,
  // },
  {
    url: '/inventory/templates',
    feature_id: 9,
    view: 1,
  },
  {
    url: '/inventory/templates/view',
    feature_id: 9,
    view: 1,
  },
  {
    url: '/inventory/templates/edit',
    feature_id: 9,
    update: 1,
  },
  {
    url: '/inventory/templates/create',
    feature_id: 9,
    create: 1,
  },
  {
    url: '/inventory/log',
    feature_id: 10,
    view: 1,
  },
  {
    url: '/inventory/log/items',
    feature_id: 10,
    view: 1,
  },
  {
    url: '/inventory/close',
    feature_id: 11,
    view: 1,
  },
  {
    url: '/inventory/wastage',
    feature_id: 12,
    view: 1,
  },
  {
    url: '/inventory/wastage-recipe',
    feature_id: 13,
    view: 1,
  },
  {
    url: '/inventory/staff-consumption',
    feature_id: 14,
    view: 1,
  },
  {
    url: '/inventory/stock-control',
    feature_id: 14,
    view: 1,
  },
  {
    url: '/dashboard',
    feature_id: 15,
    view: 1,
  },
  {
    url: '/settings',
    feature_id: 16,
    view: 1,
  },
  {
    url: '/settings/accounts',
    feature_id: 16,
    view: 1,
  },
  {
    url: '/settings/business',
    feature_id: 16,
    view: 1,
  },
  {
    url: '/settings/sequence',
    feature_id: 16,
    view: 1,
  },
  {
    url: '/inventory/pos',
    feature_id: 23,
    view: 1,
  },
];
